import React, { useEffect, useRef, useState } from "react";
import style from "./addproduct.module.css";
import { Icons } from "../utils/Icons";
import { RxCross2 } from "react-icons/rx";
import { IoIosSave } from "react-icons/io";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Trash2, Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetCategorisQuery,
  useGetProductByIdQuery,
  usePostProductMutation,
  useUpdateProductMutation,
} from "../redux/apislice";
import { toast } from "react-hot-toast";
import { Button } from "@headlessui/react";
import { productSchema } from "../utils/validator";
import { useParams } from "react-router-dom";

let shipingobject = { destinationCountryName: "", cost: "", days: "" };

function AddProduct() {
  const [updateProduct, { isLoading: updating }] = useUpdateProductMutation();

  const { productId } = useParams();
  const { isLoading: cat_loader, data: cat_data } = useGetCategorisQuery();
  const { isLoading: updating_loader, data: update_data } =
    useGetProductByIdQuery(productId, {
      skip: !productId,
    });

  const [value, setValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState([]);
  const [images, setImages] = useState([]);
  const [variations, setVariations] = useState([]);

  const [input, setinput] = useState({
    title: "",
    categoryId: -1,
    subcategoryId: -1,
    final_category: -1,
    content: "",
    on_price: 0,
    off_price: 0,
    stock: 0,
    short_des: "",
  });
  const [shippinginfo, setshippinginfo] = useState([shipingobject]);
  const [subCategory, setsubCategory] = useState([]);

  const fileInputRef = useRef(null);
  const [postProduct, { isLoading }] = usePostProductMutation();

  const addTag = () => {
    if (inputValue.trim() && !tags.includes(inputValue)) {
      setTags([...tags, inputValue.trim()]);
    }
    setInputValue("");
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleAddImage = (event) => {
    event.preventDefault();
    const files = event.target.files;
    const newImages = Array.from(files).map((file) => ({
      id: URL.createObjectURL(file),
      file,
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  const handleRemoveImage = (id) => {
    setImages(images.filter((image) => image.id !== id));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const newImages = Array.from(files).map((file) => ({
      id: URL.createObjectURL(file),
      file,
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  const openFilePicker = () => {
    fileInputRef.current.click();
  };

  const handleAddVariation = () => {
    setVariations([
      ...variations,
      {
        name: "Variant Name (Like Size/Color)",
        options: [{ value: "", price: 0, stock: 0 }],
      },
    ]);
  };
  const handleRemoveVariation = (index) => {
    setVariations(variations.filter((_, i) => i !== index));
  };
  const addOption = (variationIndex) => {
    setVariations((prev) =>
      prev.map((variation, i) =>
        i === variationIndex
          ? {
              ...variation,
              options: [
                ...variation.options,
                { value: "", price: 0, stock: 0 },
              ],
            }
          : variation
      )
    );
  };

  const removeOption = (variationIndex, optionIndex) => {
    setVariations((prev) =>
      prev.map((variation, i) =>
        i === variationIndex
          ? {
              ...variation,
              options: variation.options.filter((_, j) => j !== optionIndex),
            }
          : variation
      )
    );
  };

  const handleAddShippingInfo = () => {
    setshippinginfo([...shippinginfo, shipingobject]);
  };

  const removeVariableFromVariation = (index, variableName) => {
    setVariations((prevVariations) =>
      prevVariations
        .map((item, i) => {
          if (i === index) {
            const { [variableName]: _, ...rest } = item;
            return rest;
          }
          return item;
        })
        .filter((item) => Object.keys(item).length > 0)
    );
  };

  const addVariableToVariation = (index, variableName) => {
    const isValidVariableName = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(variableName);

    if (!isValidVariableName) {
      alert(
        "Invalid variable name. It must not contain spaces or special characters."
      );
      return;
    }

    setVariations((prevVariations) =>
      prevVariations.map((item, i) =>
        i === index ? { ...item, [variableName]: "" } : item
      )
    );
  };

  // const handleVariationChange = (index, field, value) => {
  //   const updatedVariations = [...variations];
  //   updatedVariations[index][field] = value;
  //   setVariations(updatedVariations);
  // };
  const handleOptionChange = (variationIndex, optionIndex, field, value) => {
    setVariations((prev) =>
      prev.map((variation, i) =>
        i === variationIndex
          ? {
              ...variation,
              options: variation.options.map((opt, j) =>
                j === optionIndex ? { ...opt, [field]: value } : opt
              ),
            }
          : variation
      )
    );
  };

  const handleSubmit = async () => {
    // const shippingInfo = [
    //   {
    //     destination: "Karachi",
    //     cost: 50,
    //     estimatedDays: "5-7 days",
    //   },
    // ];

    const productData = {
      title: input.title,
      content: input.content,
      on_price: Number(input.on_price),
      off_price: Number(input.off_price),
      original_price: Number(input.on_price),
      discount: input.discount ?? undefined,
      categoryId: Number(input.categoryId),
      stock: Number(input.stock),
      warehouse: "Qamar sialvi road gujrat",
      images: images.map((img) => img.file),
      // shippingInfo,
      shortdes: input.short_des,
      tags,
      variations,
    };
    const result = productSchema.safeParse(productData);
    if (!result.success) {
      console.log(result.error);

      const message = JSON.parse(result.error)[0].message;

      toast.error(message);
      return;
    }
    console.log(input);
    
    const formData = new FormData();
    formData.append("title", input.title);
    formData.append("content", input.content);
    formData.append("on_price", input.on_price);
    formData.append("off_price", input.off_price);
    formData.append("stock", input.stock);
    formData.append("shortdes", input.short_des);
    formData.append("categoryId", input.final_category);
    // formData.append("shippingInfo", shippingInfo);
    formData.append("warehouse", "Qamar sialvi road gujrat");
    tags.forEach((tag) => {
      formData.append("tags", tag);
    });
    // shippingInfo.forEach((obj) => {
    //   formData.append("shippingInfo", JSON.stringify(obj));
    // });
    variations.forEach((obj) => {
      formData.append("variations", JSON.stringify(obj));
    });

    images.forEach((img) => formData.append("images", img.file));

    console.log(formData);

    try {
      const res = await postProduct(formData).unwrap();
      toast.success("Product posted successfully!");
      console.log(res);
    } catch (error) {
      console.error("Product post failed:", error);

      const errorMessage =
        error?.data?.message ||
        error?.error ||
        error?.message ||
        "Login failed. Please try again.";

      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (update_data?.data && cat_data?.data) {
      if (cat_data?.data[0]?.children?.length >= 1) {
        console.log(cat_data.data[0].children);

        setsubCategory(cat_data?.data[0]?.children);
      }

      var cat_id;
      var sub_cat_id;
      if (update_data?.data?.category?.parent) {
        cat_id = update_data?.data?.category?.parent?.id;
        sub_cat_id = update_data?.data?.category?.id;
        // setsubCategory([update_data?.data?.category]);
      } else {
        cat_id = update_data?.data?.category?.id;
      }
      console.log(cat_id);

      setinput((prevInput) => ({
        ...prevInput,
        title: update_data?.data?.title,
        content: update_data?.data?.content,
        short_des: update_data?.data?.shortdes,
        off_price: update_data?.data?.off_price,
        on_price: update_data?.data?.on_price,
        stock: update_data?.data?.stock,
        subcategoryId: sub_cat_id ?? -1,
        categoryId: cat_id ?? -1,
        final_category:update_data?.data?.category?.id
      }));

      setImages(update_data?.data?.images);
      setTags(update_data?.data?.productTags?.map((e) => e?.tag?.name) || []);
      setVariations(update_data?.data?.variations);
    }
  }, [update_data?.data, cat_data?.data]);
  const handleSelect = (obj) => {
    if (obj?.children.length >= 1) {
      setsubCategory(obj?.children);
      return;
    }

    setsubCategory([]);
  };
  const handleUpdate = async () => {
    
    const formData = new FormData();
    formData.append("productId", productId);
    formData.append("title", input.title);
    formData.append("content", input.content);
    formData.append("on_price", input.on_price);
    formData.append("off_price", input.off_price);
    formData.append("stock", input.stock);
    formData.append("categoryId", input.final_category);
    formData.append("shortdes", input.short_des);
    tags.forEach((t) => formData.append("tags", t));
    variations.forEach((v) => formData.append("variations", JSON.stringify(v)));
    // images.forEach((img) => formData.append("images", img.file));

    await updateProduct({ productId, productData: formData })
      .unwrap()
      .then(() => toast.success("Product updated successfully!"))
      .catch(() => toast.error("Failed to update product!"));
  };
  if (updating_loader && productId) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-white/60 z-50">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full"
        />
      </div>
    );
  }

  return (
    <>
      <div className={style.rightSide}>
        <span className={style.label}>Add New Products</span>
        <div className={style.card}>
          <div className="flex item-center justify-between">
            <span className="hidden md:flex text-lg font-semibold text-gray-800 tracking-wide">
              Product Details
            </span>

            <div>
              <div className="flex gap-3">
                <button
                  type="button"
                  className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-300 text-gray-600 hover:bg-gray-100 transition shadow-sm"
                >
                  <Icons.RxCross2 size={18} />
                  Cancel
                </button>

                {isLoading ? (
                  <span className="flex items-center px-4 py-2 rounded-xl bg-indigo-500 text-white shadow-md">
                    Loading...
                  </span>
                ) : productId ? (
                  <button
                    onClick={handleUpdate}
                    className="flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 shadow-md transition"
                  >
                    <Icons.IoIosSave size={18} />
                    Update Product
                  </button>
                ) : (
                  <button
                    onClick={handleSubmit}
                    className="flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 shadow-md transition"
                  >
                    <Icons.IoIosSave size={18} />
                    Save Product
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className={style.genInfoCard}>
            <div className={style.infoCard}>
              <strong>General Information</strong>
              <div className={style.titleInput}>
                <text>Product Name</text>
                <input
                  placeholder="Enter Product title"
                  value={input.title}
                  onChange={(e) =>
                    setinput((input) => ({ ...input, title: e.target.value }))
                  }
                />
              </div>
              <div className={style.shortInput}>
                <label>Short Description ({input.short_des.length}/160)</label>
                <textarea
                  className={style.textArea}
                  value={input.short_des}
                  minLength={140}
                  maxLength={160}
                  onChange={(e) =>
                    setinput((prev) => ({ ...prev, short_des: e.target.value }))
                  }
                  rows={4}
                  placeholder="Write a short description..."
                />
              </div>

              <div className={style.desInput}>
                <text>Description</text>
                <ReactQuill
                  theme="snow"
                  value={input.content}
                  className={style.quillEditor}
                  onChange={(val) => {
                    setinput((input) => ({ ...input, content: val }));
                  }}
                />
              </div>
            </div>

            <div className={style.categoryCard}>
              <strong>Category</strong>
              <div className={style.titleInput}>
                <text>Select Category</text>
                {cat_loader ? (
                  <div>Loading</div>
                ) : (
                  <select
                    className={style.selectMenu}
                    value={Number(input.categoryId)}
                    onChange={(event) => {
                      event.preventDefault();
                      console.log(event.target.value);

                      if (event.target.value != "select") {
                        const obj = cat_data?.data.find(
                          (e) => e.id == Number(event.target.value) // use Number to avoid type mismatch
                        );
                        console.log(obj);

                        setinput((input) => ({
                          ...input,
                          categoryId: obj.id,
                          final_category: obj.id,
                        }));

                        handleSelect(obj);

                        return;
                      }
                      setsubCategory([]);
                      setinput((input) => ({
                        ...input,
                        categoryId: -1,
                        final_category: -1,
                      }));
                    }}
                  >
                    <option value="select">Select Category</option>
                    {cat_data?.data?.map((e, idx) => (
                      <option key={idx} value={e.id}>
                        {e?.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              {subCategory?.length >= 1 && (
                <div className={style.titleInput}>
                  <text>SubCategory</text>
                  <select
                    value={input?.subcategoryId}
                    className={style.selectMenu}
                    onChange={(event) => {
                      event.preventDefault();

                      if (event.target.value != "select") {
                        setinput((input) => ({
                          ...input,
                          subcategoryId: event.target.value,
                          final_category: event.target.value,
                        }));
                        return;
                      }
                      setinput((input) => ({
                        ...input,
                        subcategoryId: -1,
                        final_category: -1,
                      }));
                    }}
                  >
                    <option value={"select"}>Select SubCategory</option>

                    {subCategory.map((e) => (
                      <option value={e.id}>{e?.name}</option>
                    ))}
                  </select>
                </div>
              )}
              <div className={style.titleInput}>
                <text>Product Tags</text>
                <div className={style.tagsContainer}>
                  {tags.map((tag, index) => (
                    <div key={index} className={style.tag}>
                      <span>{tag}</span>
                      <button
                        className={style.closeButton}
                        onClick={() => removeTag(tag)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                  <input
                    className={style.input}
                    type="text"
                    value={inputValue}
                    placeholder="Add a tag..."
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && addTag()}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={style.infoCard}>
            <strong>Media</strong>

            <div className={style.container}>
              <h3>Photo</h3>
              <div
                className={style.dropZone}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                {images.length === 0 ? (
                  <p>Drag and drop image here, or click add image</p>
                ) : (
                  <div className={style.imagePreviewContainer}>
                    {images.map((image) => (
                      <div key={image.id} className={style.imageWrapper}>
                        <img
                          src={productId ? image.url : image.id}
                          alt="Uploaded preview"
                          className={style.image}
                        />
                        <button
                          className={style.deleteButton}
                          onClick={() => handleRemoveImage(image.id)}
                        >
                          <Icons.MdDelete />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleAddImage}
                ref={fileInputRef}
                className={style.fileInput}
              />
              <button className={style.addButton} onClick={openFilePicker}>
                Add Image
              </button>
            </div>

            {/* <div className={style.container}>
              <h3>Video</h3>
              <div
                className={style.dropZone}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                {images.length === 0 ? (
                  <p>Drag and drop video here, or click video</p>
                ) : (
                  <div className={style.imagePreviewContainer}>
                    {images.map((image) => (
                      <div key={image.id} className={style.imageWrapper}>
                        <img
                          src={image.id}
                          alt="Uploaded preview"
                          className={style.image}
                        />
                        <button
                          className={style.deleteButton}
                          onClick={() => handleRemoveImage(image.id)}
                        >
                          <Icons.MdDelete />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleAddImage}
                ref={fileInputRef}
                className={style.fileInput}
              />
              <button className={style.addButton} onClick={openFilePicker}>
                Add Video
              </button>
            </div> */}
          </div>
          <div className={style.infoCard}>
            <strong>Pricing</strong>
            <div className="w-full flex flex-col  gap-2 md:gap-5 md:flex-row  ">
              <div className={style.titleInput}>
                <text>Off Price (Like Offer and Discount)</text>
                <input
                  type="number"
                  placeholder="Enter off Price"
                  value={input.off_price}
                  onChange={(e) =>
                    setinput((input) => ({
                      ...input,
                      off_price: e.target.value,
                    }))
                  }
                />
              </div>

              <div className={style.titleInput}>
                <text>Sales Price (if add discount)</text>
                <input
                  type="number"
                  placeholder="Enter Price"
                  value={input.on_price}
                  onChange={(e) =>
                    setinput((input) => ({
                      ...input,
                      on_price: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex flex-col gap-2 md:gap-5 md:flex-row ">
              <div className={style.titleInput}>
                <text>Discount Precentage (8.3%)</text>
                <input type="number" disabled placeholder="Enter Price" />
              </div>
              <div className={style.titleInput}>
                <text>Quantity (Stock)</text>
                <input
                  type="number"
                  placeholder="Enter Quantity"
                  value={input.stock}
                  onChange={(e) =>
                    setinput((input) => ({ ...input, stock: e.target.value }))
                  }
                />
              </div>
            </div>
          </div>
          {/* <div className={style.infoCard}>
            <strong>Pricing</strong>
            <div className={style.genInfoCard}>
         
              <div className={style.titleInput}>
                <text>Processing TIme</text>
                <input type="text" placeholder="Enter Processing TIme" />
              </div>
            </div>
            <div className={style.titleInput}>
              <text>Company Name</text>
              <input type="text" placeholder="Enter Company Name" />
            </div>

            <div className={style.desInput}>
              <text>Return Policy</text>
              <ReactQuill
                theme="snow"
                value={value}
                className={style.quillEditor}
                onChange={setValue}
              />
            </div>
          </div> */}
          <div className={style.infoCard}>
            <div className={style.variationSection}>
              <h3>Variations</h3>
              {variations.map((variation, i) => (
                <div key={i} className={style.variationRow}>
                  <input
                    type="text"
                    value={variation.name}
                    placeholder="Variation Name (e.g., Size, Color)"
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setVariations((prev) =>
                        prev.map((v, idx) =>
                          idx === i ? { ...v, name: newValue } : v
                        )
                      );
                    }}
                  />

                  <div className="w-full flex flex-wrap gap-6">
                    {variation.options.map((opt, j) => (
                      <div
                        key={j}
                        className="flex flex-col md:flex-row gap-4 p-4 bg-white border border-gray-200 rounded-2xl shadow-sm md:items-end
                w-[100%] md:w-[100%] "
                      >
                        <div className="flex flex-col gap-1">
                          <label className="text-sm font-medium text-gray-700">
                            Value
                          </label>
                          <input
                            type="text"
                            value={opt.value}
                            onChange={(e) =>
                              handleOptionChange(i, j, "value", e.target.value)
                            }
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter value"
                          />
                        </div>

                        <div className="flex flex-col gap-1">
                          <label className="text-sm font-medium text-gray-700">
                            Price
                          </label>
                          <input
                            type="number"
                            min="0"
                            step="1"
                            value={opt.price}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "") {
                                handleOptionChange(i, j, "price", "");
                                return;
                              }
                              const num = Number(val);
                              if (!isNaN(num) && num > 0) {
                                handleOptionChange(i, j, "price", num);
                              }
                            }}
                            onBlur={(e) => {
                              const num = Number(e.target.value);
                              handleOptionChange(
                                i,
                                j,
                                "price",
                                isNaN(num) ? 0 : num
                              );
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter price"
                          />
                        </div>

                        <div className="flex flex-col gap-1">
                          <label className="text-sm font-medium text-gray-700">
                            Stock
                          </label>
                          <input
                            type="number"
                            inputMode="numeric"
                            value={opt.stock}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "") {
                                handleOptionChange(i, j, "stock", "");
                                return;
                              }
                              const num = Number(val);
                              if (!isNaN(num) && num > 0) {
                                handleOptionChange(i, j, "stock", num);
                              }
                            }}
                            onBlur={(e) => {
                              const num = Number(e.target.value);
                              handleOptionChange(
                                i,
                                j,
                                "stock",
                                isNaN(num) ? 0 : num
                              );
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Enter stock"
                          />
                        </div>

                        <button
                          type="button"
                          onClick={() => removeOption(i, j)}
                          className="h-10 flex items-center justify-center gap-2 px-4 rounded-lg 
             bg-red-500 text-white hover:bg-red-600 active:scale-95 transition shadow-sm mb-[4px]"
                        >
                          <Icons.MdDelete size={18} />
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>

                  <div className="flex gap-3 mt-2 flex-col md:flex-row">
                    <button
                      onClick={() => addOption(i)}
                      className="flex items-center gap-2 px-4 py-2 rounded-2xl bg-green-500 text-white hover:bg-green-600 shadow-md transition"
                    >
                      <Plus size={18} /> Add Option
                    </button>
                    <button
                      onClick={() => handleRemoveVariation(i)}
                      className="flex items-center gap-2 px-4 py-2 rounded-2xl bg-red-500 text-white hover:bg-red-600 shadow-md transition"
                    >
                      <Trash2 size={18} /> Delete Variation
                    </button>
                  </div>
                </div>
              ))}
              <button className={style.addButton} onClick={handleAddVariation}>
                + Add Variant
              </button>
            </div>
          </div>

          {/* <div className={style.infoCard}>
            <strong>Shipping</strong>
            <div className={style.variationSection}>
              {shippinginfo.map((variation, index) => (
                <div key={index} className={style.variationRow}>
                  {Object.keys(variation).map((e) => (
                    <div className={style.titleInput}>
                      <text>{e.charAt(0).toUpperCase() + e.slice(1)}</text>
                      <input type="number" placeholder="Enter Quantity" />
                    </div>
                  ))}
                  <button
                    className={style.delect}
                    onClick={() => handleRemoveVariation(index)}
                  ></button>
                  <button
                    class={style["delete-btn"]}
                    onClick={() => handleRemoveVariation(index)}
                  >
                    Delete
                  </button>
                </div>
              ))}
              <button
                className={style.addButton}
                onClick={handleAddShippingInfo}
              >
                + Add ShippingInfo
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default AddProduct;
